import { render, staticRenderFns } from "./OcrVerificationForm.vue?vue&type=template&id=5f1339c9&"
import script from "./OcrVerificationForm.vue?vue&type=script&lang=js&"
export * from "./OcrVerificationForm.vue?vue&type=script&lang=js&"
import style0 from "./OcrVerificationForm.vue?vue&type=style&index=0&id=5f1339c9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports